import { Component, Output, Input, EventEmitter, OnChanges, AfterContentInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ErrorObject } from '../errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { PackagingCodeService } from '../packaging-code/packaging-code.service';
import { ConstraintListBE } from '../packaging-code/shared/packaging-code.model';
import { PackagingMaterialListBE } from '../packaging-material/shared/packaging-material.model';
import { PkgInstrLevelInfo, PkgInstrLevelMaterialBE, PkgInstrLevelAdditionalMaterialBE } from './shared/packaging-instruction.model';
import { PackageInstructionService } from './packaging-instruction.service';
import { AttributeListBE } from '../shared/attribute-list.model';
import { PackagingMaterialAttirbuteService } from '../packaging-material-attributes/packaging-material-attributes.service';
import { ConfirmResult } from '../dialogboxes/shared/confirm.model';
import { element } from 'protractor';
import { ChineseChangeValueService } from '../chinese-change-value.service';


@Component({
    moduleId: module.id,
    selector: 'packaging-instruction-material',
    templateUrl: 'packaging-instruction-material.html',
    providers: [PackagingCodeService, PackageInstructionService, PackagingMaterialAttirbuteService,ChineseChangeValueService],
    styleUrls: ['packaging-instruction-material.css']
})
export class PackagingInstructionMaterialComponent implements OnChanges, AfterContentInit {
    @Input() instructionId: number;
    @Input() subLevelCodeExists: boolean;
    @Input() levelInfo: PkgInstrLevelInfo;
    @Output() levelDlgExecuteCommand: EventEmitter<PkgInstrLevelInfo> = new EventEmitter<PkgInstrLevelInfo>();

    localLevelInfo: PkgInstrLevelInfo;
    constraintList: ConstraintListBE[] = new Array<ConstraintListBE>();
    selectedLevel: number;
    hasSubLevels = false;

    errorObj: ErrorObject = null;
    currentDlg: NgbModalRef;

    showSpinner = false;
    isDirty = false;
    mhNumber: Array<string> = [];
    level1mh: Array<string> = [];
    additionamMaterial: Array<string> = [];
    deletedMh: Array<string> = [];
    isexist: boolean;
    mhExclusionlist: Array<string> = [];
    intersection: Array<string> = [];
    currentListText: string = "";
    qtyAdditionalMaterial: number;

    // confirm dialog
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    confirmDlgText: string = "";

    showCodeSearchSpinner;
    codeMaterial;

    constructor(private codeService: PackagingCodeService,
        private pkgInstrService: PackageInstructionService,
        private errHandler: ErrorHandlerService,
        private materialAttrService: PackagingMaterialAttirbuteService,
        private modalService: NgbModal,
        public ChineseChangeValueService:ChineseChangeValueService
        ) { }
        EnglishToChineseText:Record<string,string>= //function for dictionary of english to chinese word
        {
            'Edit level':'編輯級別',
            'Add code':'添加代碼',
            'Add additional material':'添加其他材料',
            'No code or addtional material exist for this level':'此級別不存在代碼或其他材料',
            'Click Add code and/or Add additional material button to add code/material':'按下添加代碼和/或添加其他材料按鈕以添加代碼/材料',
            'Loading packaging codes':'載入包裝代碼',
            'Part qty in unit':'零件數量單位',
            'Please enter a number bigger than zero':'請輸入大於零的數位',
            'Packaging Material':'包裝材料',
            'Quantity':'數量',
            'Description':'描述',
            'Please make sure that Packaging code longer than 2 is only selected for SL-Internal':'請確保僅為 SL-內部選擇長度大於 2 的打包代碼',
            'You have selected a code with sub level contraints, please select packaging code for level 2':'您選擇了帶有子級別限制的代碼，請選擇級別 2 的包裝代碼',
            'When you press the update button level 2 packaging code will be replaced and level 3 packaging code (if any) will be deleted':'當您按下更新按鈕時，2級包裝代碼將被替換，並且 3 級包裝代碼（如果有）將被刪除',
            'Packaging code':'包裝代碼',
            'Qty Of Unit':'凱蒂本烏尼特',
            'Additional material':'阿迪蒂奧納爾馬特里亞爾',
            'Update instruction':'厄普達特英斯特勒克蒂翁'
       
        }; 

    ngOnChanges() {
        this.hasSubLevels = this.subLevelCodeExists;
        this.createLocalLevelInfoObject(this.levelInfo);
        this.selectedLevel = this.levelInfo.Level;

        if (this.localLevelInfo.ConstraintCodeId != null) {
            this.loadCodeConstraints(this.localLevelInfo.CodeId);
        }
    }

    ngAfterContentInit() {
        this.isDirty = false;
    }

    loadPackingCode(codeId: number) {
        this.showSpinner = true;
        this.errorObj = null;
        this.constraintList = [];

        this.pkgInstrService.getNewLevelInfoFor(codeId)
            .subscribe(returnObject => this.loadPackingCodeResult(returnObject));
    }

    loadPackingCodeResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructio2nMaterialComponent.loadPackingCodeResult', returnObject.ErrorType);
        } else {
            if (returnObject.DataList.length > 0) {
                var tempAdditionalMaterials = this.localLevelInfo.AdditionalMaterials;
                this.localLevelInfo = returnObject.DataList[0];
                this.localLevelInfo.AdditionalMaterials = tempAdditionalMaterials;
                this.localLevelInfo.Level = this.selectedLevel;
                this.localLevelInfo.InstructionId = this.instructionId;

                if (this.localLevelInfo.HasConstraintCode) {
                    this.loadCodeConstraints(this.localLevelInfo.CodeId);
                }
                this.fillMhNumber(returnObject);
            }
        }
        this.showSpinner = false;
    }

    fillMhNumber(returnObject: IReturnObject) {
        this.mhNumber = [];
        this.localLevelInfo.CodeMaterials.forEach(element => {
            if (element.MHNo != null) {
                this.mhNumber.push(element.MHNo);
            }
        });

    }

    loadCodeConstraints(codeId: number) {
        this.showSpinner = true;
        this.errorObj = null;

        this.codeService.getCodeConstraints(codeId)
            .subscribe(returnObject => this.loadCodeConstraintsResult(returnObject));
    }

    loadCodeConstraintsResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingInstructio2nMaterialComponent.loadCodeConstraintsResult', returnObject.ErrorType);
        }
        else {
            this.constraintList = returnObject.DataList;
            this.localLevelInfo.IsConstraintCode = false;
            this.localLevelInfo.HasConstraintCode = true;
            if (this.localLevelInfo.ConstraintCodeId == null) {
                this.localLevelInfo.ConstraintCodeId = this.constraintList.length > 0
                    ? this.constraintList[0].ConstraintId
                    : null;
            }
        }
        this.showSpinner = false;
    }

    createLocalLevelInfoObject(lvlInfo: PkgInstrLevelInfo) {
        this.localLevelInfo = new PkgInstrLevelInfo(lvlInfo.Level);
        this.localLevelInfo.CodeId = lvlInfo.CodeId;
        this.localLevelInfo.ConstraintCodeId = lvlInfo.ConstraintCodeId;
        this.localLevelInfo.Description = lvlInfo.Description;
        this.localLevelInfo.HasConstraintCode = lvlInfo.HasConstraintCode;
        this.localLevelInfo.Height = lvlInfo.Height;
        this.localLevelInfo.InstructionId = lvlInfo.InstructionId;
        this.localLevelInfo.IsConstraintCode = lvlInfo.IsConstraintCode;
        this.localLevelInfo.Length = lvlInfo.Length;
        this.localLevelInfo.LevelComment = lvlInfo.LevelComment;
        this.localLevelInfo.LevelSubNumbering = lvlInfo.LevelSubNumbering;
        this.localLevelInfo.LevelToSubNumbering = lvlInfo.LevelToSubNumbering;
        this.localLevelInfo.PackagingCode = lvlInfo.PackagingCode;
        this.localLevelInfo.PartText = lvlInfo.PartText;
        this.localLevelInfo.QuantityInLevel = lvlInfo.QuantityInLevel;
        this.localLevelInfo.QuantityOfLevel = lvlInfo.QuantityOfLevel;
        this.localLevelInfo.Weight = lvlInfo.Weight;
        this.localLevelInfo.Width = lvlInfo.Width;
        this.localLevelInfo.CodeMaterials = this.createLocalCodeMaterialObject(lvlInfo);
        this.localLevelInfo.AdditionalMaterials = this.createLocalAdditionalMaterialObject(lvlInfo);
    }

    createLocalCodeMaterialObject(lvlInfo: PkgInstrLevelInfo) {
        const codeMaterial: PkgInstrLevelMaterialBE[] = new Array<PkgInstrLevelMaterialBE>();
        for (let i = 0; i < lvlInfo.CodeMaterials.length; i++) {
            const item: PkgInstrLevelMaterialBE = new PkgInstrLevelMaterialBE();
            item.Description = lvlInfo.CodeMaterials[i].Description;
            item.InstructionId = lvlInfo.CodeMaterials[i].InstructionId;
            item.Level = lvlInfo.CodeMaterials[i].Level;
            item.MaterialId = lvlInfo.CodeMaterials[i].MaterialId;
            item.MHNo = lvlInfo.CodeMaterials[i].MHNo;
            item.Quantity = lvlInfo.CodeMaterials[i].Quantity;
            item.Weight = lvlInfo.CodeMaterials[i].Weight;
            codeMaterial.push(item);
        }
        return codeMaterial;
    }

    createLocalAdditionalMaterialObject(lvlInfo: PkgInstrLevelInfo) {
        const additionalMaterial: PkgInstrLevelAdditionalMaterialBE[] = new Array<PkgInstrLevelAdditionalMaterialBE>();
        for (let i = 0; i < lvlInfo.AdditionalMaterials.length; i++) {
            const item: PkgInstrLevelAdditionalMaterialBE = new PkgInstrLevelAdditionalMaterialBE();
            item.Description = lvlInfo.AdditionalMaterials[i].Description;
            item.InstructionId = lvlInfo.AdditionalMaterials[i].InstructionId;
            item.Level = lvlInfo.AdditionalMaterials[i].Level;
            item.MaterialId = lvlInfo.AdditionalMaterials[i].MaterialId;
            item.MHNo = lvlInfo.AdditionalMaterials[i].MHNo;
            item.Quantity = lvlInfo.AdditionalMaterials[i].Quantity;
            item.Weight = lvlInfo.AdditionalMaterials[i].Weight;
            item.PartText = lvlInfo.AdditionalMaterials[i].PartText;
            item.LevelSubNumbering = lvlInfo.AdditionalMaterials[i].LevelSubNumbering;
            item.LevelSubNumbering = lvlInfo.AdditionalMaterials[i].LevelToSubNumbering;
            additionalMaterial.push(item);
        }
        return additionalMaterial;
    }

    getMaterialExclusions() {
        this.errHandler.emitErrorObject(null);
        this.materialAttrService.getMaterialExclusions().subscribe(returnObject => {
            this.validateMaterialInLevel(returnObject.DataList);
        });
    };


    validateMaterialInLevel(dataList: AttributeListBE[]) {
        this.mhExclusionlist = [];
        dataList.forEach(element => {
            if (element.MHno != null) {
                this.mhExclusionlist.push(element.MHno)
            }
        })
        //console.log(this.levelInfo.Level);

        switch (this.levelInfo.Level) {
            case 1: {
                this.level1mh = [];
                this.intersection = [];

                this.intersection = this.mhExclusionlist.filter(x => this.mhNumber.includes(x));
                if (this.intersection.length == 0)
                    this.intersection = this.mhExclusionlist.filter(x => this.additionamMaterial.includes(x));

                if (this.intersection.length == 0) {
                    if (this.findCommonElements(this.level1mh, this.mhNumber) || this.findCommonElements(this.level1mh, this.additionamMaterial)) {
                        this.openOnSaveValidateDlg("Same material " + this.mhNumber + " " + this.additionamMaterial + "\n cannot be added in same Packaging Instruction more than once")
                        return false;
                    } else {

                        this.mhNumber.forEach((order: any) => {
                            this.level1mh.push(order);
                        });
                        this.additionamMaterial.forEach((order: any) => {
                            this.level1mh.push(order)
                        })

                        if (this.level1mh.length != 0)
                            localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));

                        this.deletedMh.forEach(element => {
                            if (element != null) {
                                let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                if (tempArray != null) {
                                    tempArray = tempArray.filter(item => item !== element);
                                    localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                                }
                            }
                        })

                        this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                    }
                } else {

                    this.mhNumber.forEach((order: any) => {
                        this.level1mh.push(order);
                    });
                    this.additionamMaterial.forEach((order: any) => {
                        this.level1mh.push(order)
                    })


                    if (this.level1mh.length != 0)
                        localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                    this.deletedMh.forEach(element => {
                        if (element != null) {
                            let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                            tempArray = tempArray.filter(item => item !== element);
                            localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                        }
                    })

                    this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                }
                this.mhNumber = [];
                this.additionamMaterial = [];
                break;
            }
            case 2: {
                this.intersection = [];
                this.level1mh = [];
                this.level1mh = JSON.parse(localStorage.getItem("MhNumber"));
                //console.log(localStorage.getItem("MhNumber"));

                if (this.level1mh != null) {
                    this.intersection = this.mhExclusionlist.filter(x => this.mhNumber.includes(x));
                    if (this.intersection.length == 0)
                        this.intersection = this.mhExclusionlist.filter(x => this.additionamMaterial.includes(x));

                    if (this.intersection.length == 0) {
                        if (this.findCommonElements(this.level1mh, this.mhNumber) || this.findCommonElements(this.level1mh, this.additionamMaterial)) {
                           // this.openOnSaveValidateDlg("Same material " + this.mhNumber + " " + this.additionamMaterial + "\n cannot be added in same Packaging Instruction more than once")
                           // return false;
                        } else {
                            this.mhNumber.forEach((order: any) => {
                                this.level1mh.push(order);
                            });
                            this.additionamMaterial.forEach((order: any) => {
                                this.level1mh.push(order)
                            })

                            localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                            this.deletedMh.forEach(element => {
                                if (element != null) {
                                    let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                    tempArray = tempArray.filter(item => item !== element);
                                    localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                                }
                            })
                            this.deletedMh = [];
                            this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                        }
                    }
                    else {
                        this.mhNumber.forEach((order: any) => {
                            this.level1mh.push(order);
                        });
                        this.additionamMaterial.forEach((order: any) => {
                            this.level1mh.push(order)
                        })

                        localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                        this.deletedMh.forEach(element => {
                            if (element != null) {
                                let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                tempArray = tempArray.filter(item => item !== element);
                                localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                            }
                        })
                        this.deletedMh = [];
                        this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                    }
                }
                else {
                    this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                }
                this.mhNumber = [];
                this.additionamMaterial = [];
                break;
            }

            case 3: {
                this.intersection = [];
                this.level1mh = [];
                this.level1mh = JSON.parse(localStorage.getItem("MhNumber"));

                if (this.level1mh != null) {

                    this.intersection = this.mhExclusionlist.filter(x => this.mhNumber.includes(x));
                    if (this.intersection.length == 0)
                        this.intersection = this.mhExclusionlist.filter(x => this.additionamMaterial.includes(x));

                    if (this.intersection.length == 0) {
                        if (this.findCommonElements(this.level1mh, this.mhNumber) || this.findCommonElements(this.level1mh, this.additionamMaterial)) {
                           // this.openOnSaveValidateDlg("Same material " + this.mhNumber + " " + this.additionamMaterial + "\n cannot be added in same Packaging Instruction more than once")
                            //return false;
                        } else {

                            this.mhNumber.forEach((order: any) => {
                                this.level1mh.push(order);
                            });
                            this.additionamMaterial.forEach((order: any) => {
                                this.level1mh.push(order)
                            })

                            localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                            this.deletedMh.forEach(element => {
                                if (element != null) {
                                    let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                    tempArray = tempArray.filter(item => item !== element);
                                    localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                                }
                            })
                            this.deletedMh = [];
                            this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                        }
                    }
                    else {
                        this.mhNumber.forEach((order: any) => {
                            this.level1mh.push(order);
                        });
                        this.additionamMaterial.forEach((order: any) => {
                            this.level1mh.push(order)
                        })


                        localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                        this.deletedMh.forEach(element => {
                            if (element != null) {
                                let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                tempArray = tempArray.filter(item => item !== element);
                                localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                            }
                        })
                        this.deletedMh = [];
                        this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                    }
                } else {
                    this.levelDlgExecuteCommand.emit(this.localLevelInfo);

                }
                this.mhNumber = [];
                this.additionamMaterial = [];
                break;
            }
            case 99: {

                this.intersection = [];
                this.level1mh = [];
                this.level1mh = JSON.parse(localStorage.getItem("MhNumber"));

                if (this.level1mh != null) {

                    this.intersection = this.mhExclusionlist.filter(x => this.additionamMaterial.includes(x));

                    if (this.intersection.length == 0) {
                        if (this.findCommonElements(this.level1mh, this.additionamMaterial)) {
                            this.openOnSaveValidateDlg("Same material " + this.additionamMaterial + "\n cannot be added in same Packaging Instruction more than once")
                            return false;
                        } else {
                            this.additionamMaterial.forEach((order: any) => {
                                this.level1mh.push(order)
                            })

                            localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                            this.deletedMh.forEach(element => {
                                if (element != null) {
                                    let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                    tempArray = tempArray.filter(item => item !== element);
                                    localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                                }
                            })
                            this.deletedMh = [];
                            this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                        }
                    } else {
                        this.additionamMaterial.forEach((order: any) => {
                            this.level1mh.push(order)
                        })

                        localStorage.setItem("MhNumber", JSON.stringify(this.level1mh));
                        this.deletedMh.forEach(element => {
                            if (element != null) {
                                let tempArray = JSON.parse(localStorage.getItem("MhNumber"));
                                tempArray = tempArray.filter(item => item !== element);
                                localStorage.setItem("MhNumber", JSON.stringify(tempArray));
                            }
                        })
                        this.deletedMh = [];
                        this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                    }
                } else {
                    this.levelDlgExecuteCommand.emit(this.localLevelInfo);
                }
                this.mhNumber = [];
                this.additionamMaterial = [];
                break;
            }
        }
    }

    openOnSaveValidateDlg(text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "savefail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'Level Information';
        this.confirmDlgText = text;
        this.dialogAppliesToId = this.instructionId;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }

    onConfirmDlgNotify(command: ConfirmResult): void {
        this.currentDlg.close();
    }
    onEditCodeDlgOk() {
        if (this.localLevelInfo.AdditionalMaterials.length > 0 && this.localLevelInfo.CodeMaterials.length > 0) {
            if (this.localLevelInfo.QuantityInLevel == 0 || this.localLevelInfo.QuantityOfLevel == 0 || this.localLevelInfo.QuantityInLevel == null
                || this.localLevelInfo.QuantityOfLevel == null) {
                this.openOnSaveValidateDlg("Part quantity in unit can not be Zero")
                return false;
            } else if (this.qtyAdditionalMaterial == 0 || this.additionamMaterial == null) {
                this.openOnSaveValidateDlg("Additional Material Quantity can not be Zero")
                return false;

            } else {
                this.getMaterialExclusions();
            }
        } else if (this.localLevelInfo.AdditionalMaterials.length > 0 && this.localLevelInfo.CodeMaterials.length == 0) {
            if (this.qtyAdditionalMaterial == 0 || this.additionamMaterial == null) {
                this.openOnSaveValidateDlg("Additional Material Quantity can not be Zero")
                return false;
            } else {
                this.getMaterialExclusions();
            }
        } else if (this.localLevelInfo.AdditionalMaterials.length == 0 && this.localLevelInfo.CodeMaterials.length > 0) {
            if (this.localLevelInfo.QuantityInLevel == 0 || this.localLevelInfo.QuantityOfLevel == 0 || this.localLevelInfo.QuantityInLevel == null
                || this.localLevelInfo.QuantityOfLevel == null) {
                this.openOnSaveValidateDlg("Part quantity of unit can not be Zero")
                return false;
            } else {
                this.getMaterialExclusions();
            }
        } else if (this.localLevelInfo.AdditionalMaterials.length == 0 && this.localLevelInfo.CodeMaterials.length == 0) {
            this.getMaterialExclusions();
        }

    }

    findCommonElements(arr1, arr2) {
        return arr1.some(item => arr2.includes(item))
    }
    onEditCodeDlgCancel() {
        this.levelDlgExecuteCommand.emit(null);
    }

    onAddAdditionalMaterial(modal: any) {
        this.currentDlg = this.modalService.open(modal);
    }

    onAddCode(modal: any) {
      //console.log(modal);
        this.currentDlg = this.modalService.open(modal);

    }

    onSearchMaterialDialogExecute(dialogResult: PackagingMaterialListBE[]) {
        if (dialogResult == null) {
            this.closeDlg();
            return;
        }
        this.setDirty();

        for (let i = 0; i < dialogResult.length; i++) {
            const item = this.localLevelInfo.AdditionalMaterials.find(x => x.MaterialId === dialogResult[i].Id);
            if (item === undefined) {
                const newItem = new PkgInstrLevelAdditionalMaterialBE();
                newItem.MaterialId = dialogResult[i].Id;
                newItem.InstructionId = this.instructionId;
                newItem.Level = this.selectedLevel;
                newItem.Description = dialogResult[i].Description;
                newItem.MHNo = dialogResult[i].MHNo;
                newItem.Quantity = 1;
                newItem.Weight = dialogResult[i].Weight;
                this.localLevelInfo.AdditionalMaterials.push(newItem);
            }
        }
        this.additionamMaterial = []
        this.localLevelInfo.AdditionalMaterials.forEach(element => {
            if (element.MHNo != null) {
                this.additionamMaterial.push(element.MHNo);
            }
        });

        this.closeDlg();
    }

    onSearchCodeDialogExecute(codetId: number) {
        if (codetId == null) {
            this.closeDlg();
            return;
        }

        this.setDirty();
        this.loadPackingCode(codetId);
        this.closeDlg();
    }

    onDeleteAdditionalMaterial(material: PkgInstrLevelAdditionalMaterialBE) {
        if (this.additionamMaterial.length == 0) { this.deletedMh.push(material.MHNo); }

        this.additionamMaterial.forEach(element => {
            if (element == material.MHNo) {
                this.additionamMaterial = this.additionamMaterial.filter(item => item !== material.MHNo);

            }
        })
        this.setDirty();
        const inx = this.localLevelInfo.AdditionalMaterials.findIndex(x => x.MaterialId === material.MaterialId);
        this.localLevelInfo.AdditionalMaterials.splice(inx, 1);
    }

    onDeleteCode() {
        this.localLevelInfo.CodeMaterials.forEach(element => {
            let mhCode = element.MHNo
            if (this.mhNumber.length == 0) { this.deletedMh.push(element.MHNo); }

            this.mhNumber.forEach(insideElement => {
                if (insideElement == mhCode) {
                    this.mhNumber = this.mhNumber.filter(item => item !== element.MHNo);

                }
            })

        })

        this.setDirty();
        this.localLevelInfo.CodeMaterials = [];
    }

    closeDlg() {
        this.currentDlg.close();
    }

    setSelectedConstraintCode(constraintId: number): void {
        this.setDirty();
        this.localLevelInfo.ConstraintCodeId = null;
        this.localLevelInfo.ConstraintCodeId = constraintId;
    }

    setDirty() {
        this.isDirty = true;
    }

    isOkDisabled(): boolean {
        return this.localLevelInfo.CodeMaterials.length === 0 && this.localLevelInfo.AdditionalMaterials.length === 0;
    }

    isQtyOfLevelValueValid(): boolean {
        this.setDirty();
        return this.localLevelInfo.QuantityOfLevel > 0;
    }

    isQtyInLevelValueValid(): boolean {
        this.setDirty();
        return this.localLevelInfo.QuantityInLevel > 0;
    }

    isQtyAdditionalMaterialValid(): boolean {
        this.setDirty();
        if (this.localLevelInfo.AdditionalMaterials.find(x => x.Quantity == 0)) {
            this.qtyAdditionalMaterial = 0
            return false;

        } else {
            this.qtyAdditionalMaterial = 1
            return true;
        }
    }

    isEditEnabled() {
        return (!this.hasSubLevels || this.localLevelInfo.CodeId !== this.levelInfo.CodeId)
            && !this.localLevelInfo.IsConstraintCode;
    }

    islevelInfo(): boolean {
        return this.isCodeMaterialData() || this.isAdditionalMaterialData();
    }

    isCodeMaterialData(): boolean {
        return this.localLevelInfo.CodeMaterials.length > 0;
    }

    isAdditionalMaterialData(): boolean {
        return this.localLevelInfo.AdditionalMaterials.length > 0;
    }

    isAddCodeDisabled(): boolean {
        if (this.selectedLevel === 99) {
            return true;
        }

        if (this.localLevelInfo.CodeMaterials.length > 0) {
            return true;
        }

        if (this.localLevelInfo.IsConstraintCode) {
            return true;
        }

        return false;
    }

    isDisabledDueToConstraint(): boolean {
        return this.localLevelInfo.IsConstraintCode;
    }

    isDisabledDueTolevel():boolean
    {
        if(this.localLevelInfo.Level==1)
        return true;
        else
        return false;
    }

    isConstraintChecked(codeId: number): boolean {
        return codeId === this.localLevelInfo.ConstraintCodeId;
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction/packaging-instruction-material.component.ts